// translations.ts
// Simple translation system that syncs with index.html language settings

export type Language = 'en' | 'ja';

export const translations = {
  // Common
  'powered_by_iic': {
    'en': 'Powered by IIC',
    'ja': 'Powered by IIC'
  },
  'iic_home': {
    'en': 'IIC Home',
    'ja': 'IICホーム'
  },
  'terms_of_use': {
    'en': 'Terms of Use',
    'ja': '利用規約'
  },
  'privacy_policy': {
    'en': 'Privacy Policy',
    'ja': 'プライバシーポリシー'
  },

  // Login form
  'username': {
    'en': 'Username:',
    'ja': 'ユーザー名:'
  },
  'password': {
    'en': 'Password:',
    'ja': 'パスワード:'
  },
  'username_placeholder': {
    'en': 'Username',
    'ja': 'ユーザー名'
  },
  'password_placeholder': {
    'en': 'Password',
    'ja': 'パスワード'
  },
  'login': {
    'en': 'Login',
    'ja': 'ログイン'
  },

  // Phone number form
  'phone_number': {
    'en': 'Phone Number:',
    'ja': '電話番号:'
  },
  'phone_placeholder': {
    'en': 'Add Phone Number',
    'ja': '電話番号を追加'
  },
  'set_phone_number': {
    'en': 'Set Phone Number',
    'ja': '電話番号を設定'
  },

  // Verification code form
  'sms_verification_code': {
    'en': 'SMS Verification Code:',
    'ja': 'SMS認証コード:'
  },
  'verify_placeholder': {
    'en': 'Verify',
    'ja': '確認'
  },
  'verify_code': {
    'en': 'Verify Code',
    'ja': 'コードを確認'
  },

  // Error messages
  'token_expired': {
    'en': 'Token has expired. Please re-login.',
    'ja': 'トークンの有効期限が切れました。再度ログインしてください。'
  },
  'internal_error': {
    'en': 'An internal error has occurred.',
    'ja': '内部エラーが発生しました。'
  },
  'incorrect_credentials': {
    'en': 'Incorrect username or password.',
    'ja': 'ユーザー名またはパスワードが正しくありません。'
  },
  'invalid_status': {
    'en': 'Invalid status code.',
    'ja': '無効なステータスコード。'
  }
} as const;

export type TranslationKey = keyof typeof translations;

declare global {
  interface Window {
    xyzCurrentLanguage?: Language;
  }
}

export function getLanguage(): Language {
  // Get from window (set by index.html)
  const lang = window.xyzCurrentLanguage;
  if (lang === 'ja' || lang === 'en') {
    return lang;
  }

  // Fallback: check URL params
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get('lang');
  if (urlLang === 'ja' || urlLang === 'en') {
    return urlLang;
  }

  // Fallback: check localStorage
  const storedLang = localStorage.getItem('xyz_language');
  if (storedLang === 'ja' || storedLang === 'en') {
    return storedLang;
  }

  return 'en';
}

export function t(key: TranslationKey): string {
  const lang = getLanguage();
  return translations[key]?.[lang] || translations[key]?.['en'] || key;
}
